"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "formula-editor"
  }, [_c("div", {
    staticClass: "m-m-b-8"
  }, [_vm._v(" 公式校验结果："), _c("span", {
    class: "m-type-" + _vm.status
  }, [_vm._v(_vm._s(_vm.status === "error" ? "错误=>" + _vm.result : _vm.result === undefined ? "请点击下方的按钮进行公式编辑" : "正确"))])]), _c("div", {
    staticClass: "code-mirror",
    attrs: {
      contenteditable: "false"
    }
  }, _vm._l(_vm.formulaRules, function (item, index) {
    return _c("span", {
      key: index,
      class: _vm.getItemClass(item)
    }, [_vm._v(_vm._s(item.label.toString().replace(/\#\{/g, "【").replace(/\}/g, "】")))]);
  }), 0), _c("div", {
    staticClass: "m-m-t-8"
  }, [_c("div", {
    staticClass: "m-m-b-4 m-flex m-row-between"
  }, [_c("a-tooltip", {
    attrs: {
      placement: "right",
      title: "从科目库添加科目作为运算项，同时选择多个科目时，各科目按照加法进行处理"
    }
  }, [_c("a-button", {
    attrs: {
      size: "small",
      ghost: "",
      type: "primary"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.openModal("selectCostItemModal");
      }
    }
  }, [_vm._v("+添加科目")]), _c("SelectCostItemModal", {
    ref: "selectCostItemModal",
    attrs: {
      params: _vm.params,
      method: _vm.method
    },
    on: {
      ok: _vm.handleSelectCostItemOk
    }
  })], 1), _vm.showSelectFormulaEntry && _vm.dataSource.length > 0 ? _c("span", {
    staticClass: "m-flex",
    staticStyle: {
      "line-height": "24px"
    }
  }, [_c("SelectFormulaModal", {
    ref: "selectFormulaModal",
    attrs: {
      record: _vm.record,
      "data-source": _vm.dataSource
    },
    on: {
      ok: _vm.handleSelectFormulaOk
    }
  }), _c("a", {
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.openModal("selectFormulaModal");
      }
    }
  }, [_vm._v("+选择已有公式科目")]), _c("a-tooltip", {
    attrs: {
      placement: "topRight",
      title: "从当前报表模板中选择已有公式（除当前公式外）快捷填充到当前公式中"
    }
  }, [_c("a-icon", {
    staticStyle: {
      color: "#2483ff"
    },
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1) : _vm._e(), _vm._t("extra")], 2), _c("div", {
    staticClass: "key-list"
  }, _vm._l(_vm.keys, function (item) {
    return _c("a-tag", {
      key: item.value,
      staticClass: "key-list-item",
      class: item.key,
      attrs: {
        size: "small",
        type: "primary"
      },
      on: {
        click: function ($event) {
          return _vm.handleClickKey(item);
        }
      }
    }, [_vm._v(_vm._s(item.value))]);
  }), 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;